import { Button } from "../..";
import { ColumnSelector, type ColumnSelectorProps } from "./column-selector";
import type { ActionButtonConfig } from "../data-table";
import { isValidElement, ReactNode } from "react";

export interface TableActionsProps {
  columnSelector?: ColumnSelectorProps;
  buttons?: ActionButtonConfig[];
  className?: string;
  disabled?: boolean;
}

export function TableActions({ columnSelector, buttons = [], className = "", disabled = false }: TableActionsProps) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {columnSelector && (
        <ColumnSelector {...columnSelector} disabled={disabled || columnSelector.disabled} align="right" />
      )}
      {buttons.map((btn, i) => {
        if (!isValidElement(btn)) {
          const typedBtn = btn as Exclude<ActionButtonConfig, ReactNode>;
          const Icon = typedBtn.icon;
          const showBadge = typedBtn.badge !== undefined && typedBtn.badge !== 0;
          return (
            <Button
              key={typedBtn.trackingId ?? i}
              size="sm"
              variant={typedBtn.variant ?? "default"}
              className="relative flex items-center gap-2"
              onClick={typedBtn.onClick}
              disabled={disabled || typedBtn.disabled}
              data-trackingid={typedBtn.trackingId}
              hoverLabel={typedBtn.hoverLabel}
            >
              {Icon && <Icon className="h-4 w-4" />}
              {typedBtn.label}
              {showBadge && (
                <div className="absolute -right-1.5 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-medium text-primary-foreground">
                  {typedBtn.badge}
                </div>
              )}
            </Button>
          );
        }
        return btn;
      })}
    </div>
  );
}
